import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, images } from '../data/mock';
import { ArrowLeft } from 'lucide-react';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-[#F5F7F2]">
      {/* Simple Header */}
      <header className="bg-[#1E4D2B] py-6">
        <div className="container mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white hover:text-[#FFD700] transition-colors"
          >
            <img
              src={images.logo}
              alt="MeisterGrün Logo"
              className="h-[35px] w-auto"
            />
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#2D5F3A] hover:text-[#1E4D2B] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <div className="max-w-3xl">
          <h1 className="text-4xl font-bold text-[#1E4D2B] mb-8">Datenschutzerklärung</h1>

          <div className="bg-white rounded-[32px] p-8 shadow-sm space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="text-lg font-medium text-[#1E4D2B] mb-2">Allgemeine Hinweise</h3>
              <p className="text-[#2D5F3A] leading-relaxed">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                2. Verantwortliche Stelle
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                <br /><br />
                {companyInfo.name}<br />
                {companyInfo.address.street}<br />
                {companyInfo.address.zip} {companyInfo.address.city}<br /><br />
                Telefon: {companyInfo.phone}<br />
                E-Mail: {companyInfo.email}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                3. Datenerfassung auf dieser Website
              </h2>
              <h3 className="text-lg font-medium text-[#1E4D2B] mb-2">Kontaktformular</h3>
              <p className="text-[#2D5F3A] leading-relaxed mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <h3 className="text-lg font-medium text-[#1E4D2B] mb-2">Cookies</h3>
              <p className="text-[#2D5F3A] leading-relaxed">
                Diese Website verwendet keine Cookies zu Tracking-Zwecken. Es werden lediglich
                technisch notwendige Cookies verwendet, die für den Betrieb der Website erforderlich sind.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                4. Ihre Rechte
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
                personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung
                sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
                <br /><br />
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter
                der im Impressum angegebenen Adresse an uns wenden.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                5. Google Maps
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Diese Website nutzt Google Maps zur Darstellung von Karten. Anbieter ist die
                Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
                <br /><br />
                Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern.
                Diese Informationen werden in der Regel an einen Server von Google in den USA übertragen
                und dort gespeichert.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                6. Änderung dieser Datenschutzerklärung
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den
                aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen
                in der Datenschutzerklärung umzusetzen.
                <br /><br />
                <span className="italic text-[#807979]">Stand: August 2025</span>
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Datenschutz;
